<template>
   <div class="width-100">
      <div class="width-100">
         <div class="gallery width-100">
            <!--                <Loader-->
            <!--                    color="#0275d8"-->
            <!--                    :active="loading"-->
            <!--                    spinner="line-scale"-->
            <!--                    background-color = 'rgba(255, 255, 255, .4)'-->
            <!--                />-->
            <div class="elements-wraper">

               <!--UPLOAD BUTTON-->
               <div class="button-container image-margin">
                  <label for="images-upload" class="images-upload" :class="{ 'images-upload-disabled': internal_file.length >= maxFiles || added_media.length >= maxFiles }">
                     <svg
                       class="custum-icon"
                       xmlns="http://www.w3.org/2000/svg"
                       width="1em"
                       height="1em"
                       preserveAspectRatio="xMidYMid meet"
                       viewBox="0 0 24 24">
                        <g fill="none">
                           <path
                             d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1zm1 15a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2h-3v3z"
                             fill="currentColor" />
                        </g>
                     </svg>
                  </label>
                  <input ref="fileInput" @change="fileChange" id="images-upload" type="file" accept="image/png, image/jpeg" multiple hidden :disabled="internal_file.length >= maxFiles || added_media.length >= maxFiles" />
               </div>

               <!--IMAGES PREVIEW-->

               <div v-for="(image, index) in internal_file" :key="index + Math.random()" class="image-container image-margin">
                  <img :src="media_file_path +'/'+ image.name" alt="" class="images-preview">
                  <button @click="remove_saved_media(index)" class="close-btn" type="button">
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                     </svg>
                  </button>
               </div>
               <div v-for="(image, index) in added_media" :key="index + Math.random()" class="image-container image-margin">
                  <img :src="image.url" alt="" class="images-preview">
                  <button @click="remove(index)" class="close-btn" type="button">
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                     </svg>
                  </button>
               </div>
            </div>
         </div>
      </div>
      <!--        <div v-if='error' id="media-required">-->
      <!--            <p class='red-text'>{{error}}</p>-->
      <!--        </div>-->
      <div v-for="(image, index) in added_media" :key="index + Math.random()" class="m-top">
         <input type="text" name="added_media[]" :value="image.name" hidden>
      </div>
      <div v-for="(image, index) in deleted_media" :key="index + Math.random()" class="m-top">
         <input type="text" name="deleted_media[]" :value="image.name" hidden>
      </div>
      <div v-if="added_media.length" class="m-top">
         <input type="text" ref="media" name="media" value="1" hidden id="media-media">
      </div>
   </div>
</template>

<script>
   import Compressor from "compressorjs";
   // import Loader from './loader/index.vue';
   import "../../assets/sass/uploadMedia/upload.scss";


   export default {

      data() {
         return {
            added_media: [],

            deleted_media: [],

            loading: true,
            internal_file: [...this.file]
         };
      },
      methods: {
         async fileChange(event) {
            this.loading = true;
            let files = event.target.files;

            if (this.added_media.length + files.length > this.maxFiles) {
               if (this.maxFiles === 3) {
                  this.$toast.error(this.$t("max_3_files"));
               } else {
                  this.$toast.error(this.$t("max_files"));
               }
               this.loading = false;
               return;
            }

            /////// Toto kompresne fotky na frontende
            for (var i = 0; i < files.length; i ++) {
               let formData = new FormData;
               let url = URL.createObjectURL(files[i]);
               // formData.set('image', files[i])


               let convertedBlob = await new Promise((resolve) => {
                  new Compressor(files[i], {
                     quality: 0.6,
                     maxWidth: 800,

                     success(result) {

                        resolve(result);
                     },
                     error(err) {
                        console.log(err.message);
                        resolve(files[i]); // Ak konverzia zlyhá, použite pôvodný súbor
                     }
                  });
               });

               // Konverzia Blob na File
               let file = new File([convertedBlob], files[i].name, { type: files[i].type });

               formData.set("image", file);

               const { data } = await this.$axios.post(this.server, formData);

               this.added_media.push({ url: url, name: data.name, size: file.size, type: file.type });

            }


            this.loading = false;
            this.media_emit();
         },
         reset() {
            this.internal_file = [];
            this.added_media = [];
            this.deleted_media = [];
            this.$refs.fileInput && (this.$refs.fileInput.value = null); // ak máš file input ako ref

            this.$emit("added-media", []);
            this.$emit("deleted-media", []);
         },
         remove(index) {
            this.added_media.splice(index, 1);
            this.media_emit();
         },
         remove_saved_media(index) {
            this.deleted_media.push({ name: this.internal_file[index].name });
            this.internal_file.splice(index, 1);
            this.media_emit();
         },
         media_emit() {
            this.$emit("added-media", this.added_media);
            this.$emit("deleted-media", this.deleted_media);
         }

      },
      watch: {
         file(newValue) {
            this.internal_file = [...newValue];
         }
      },
      props: {
         server: {
            type: String,
            default: "upload"
         },
         media_file_path: {
            type: String,
            required: true
         },
         file: {
            type: Array,
            default: () => []
         },
         maxFiles: {
            type: Number, // alebo String, záleží na type ID sekcie
            required: false,
            default: 3
         }
      }
   };

</script>
